import { gql } from '@apollo/client';
import { PAYMENT_FIELDS } from '../../fragments';
import { GetPaymentByIdProps, GetPaymentsByReferenceIdProps } from './payment.types';
import { PaymentType } from '../../../types';

export const GET_PAYMENTS_BY_REFERENCE_ID = gql`
  ${PAYMENT_FIELDS}
  query GetPaymentsByReferenceId($referenceId: ID!) {
    paymentsByReferenceId(referenceId: $referenceId) {
      ...PaymentFields
    }
  }
`;

export function getPaymentsByReferenceId({ client, referenceId }: GetPaymentsByReferenceIdProps) {
  return client?.watchQuery<{ paymentsByReferenceId: PaymentType[] }>({
    query: GET_PAYMENTS_BY_REFERENCE_ID,
    variables: {
      referenceId,
    },
  });
}

export const GET_PAYMENT_BY_ID = gql`
  ${PAYMENT_FIELDS}
  query fetchPaymentById($paymentId: ID!) {
    paymentByPaymentId(paymentId: $paymentId) {
      ...PaymentFields
    }
  }
`;

export function getPaymentById({ client, paymentId }: GetPaymentByIdProps) {
  return client?.watchQuery<{ paymentByPaymentId: PaymentType }>({
    query: GET_PAYMENT_BY_ID,
    variables: {
      paymentId,
    },
  });
}
